import { PRIVATE_URIS } from '../constants/privateURIs.constants';

export function reputationPath(username: string): string {
  return PRIVATE_URIS.REPUTATION.replace(':username', username);
}
